import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import route from './modules/route'
import instance from './modules/instance'
import common from './modules/common'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    route,
    instance,
    common
  }
})
